import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TerritoryService } from '../../services/territory.service';
import { publicMethods } from '../../globals';
import { ZintModalConfig, ZintModalContent } from '../../classes/types';

@Component({
  selector: 'manage-territories',
  templateUrl: './manage-territories.component.html',
  styleUrls: ['./manage-territories.component.css'],
  standalone: false,
})
export class ManageTerritoriesComponent implements OnInit {
  constructor(
    private territoryService: TerritoryService,
    private pubMethods: publicMethods,
    private cdr: ChangeDetectorRef
  ) {}

  territories: any;
  isLoading = this.territoryService.isLoading;
  organisationUsersAndTeams: any;
  showDeleteModal = false;
  territoryIdToDelete: number;
  modalConfig: ZintModalConfig;
  modalContent: ZintModalContent;

  ngOnInit(): void {
    document.title = 'Territories';
    this.listTerritories();
    this.territoryService
      .getOrganisationUsersAndTeams()
      .subscribe(data => (this.organisationUsersAndTeams = data));
  }

  listTerritories(): void {
    this.territoryService.listTerritories(true).subscribe(data => {
      this.territories = data;
      for (let territory of this.territories) {
        territory['searchParams'] =
          this.pubMethods.changeSearchParamsToDisplayFormat(
            territory['params']
          );
      }
    });
  }

  updateTerritoryEnforcement(territory): void {
    this.territoryService
      .toggleTerritoryEnforcement(territory.id)
      .subscribe(data => {
        territory.is_enforced = data.is_enforced;
        this.pubMethods.showInfoMessage('Your territory was updated.');
      });
  }

  confirmDelete(id: number) {
    this.territoryIdToDelete = id;

    this.modalConfig = {
      name: 'Confirm-Delete',
      showHeaderRow: true,
      title: 'Are you sure?',
      showConfirmBtn: true,
      confirmBtnLabel: 'Delete',
      confirmBtnClass: 'rounded-btn-red',
    };

    this.showDeleteModal = true;
    this.cdr.detectChanges();
    this.pubMethods.triggerZintModal(this.modalConfig.name);
  }

  deleteTerritory(): void {
    if (!this.territoryIdToDelete) return;
    this.territoryService
      .deleteTerritory(this.territoryIdToDelete)
      .subscribe(() => {
        this.listTerritories();
        this.territoryIdToDelete = null;
      });
  }

  handlePermissionsChange(event: any, territoryId: number): void {
    const { userId, id: teamId, selected } = event;

    let userOrTeam: 'User' | 'Team';
    if ('userId' in event && 'email' in event) {
      userOrTeam = 'User';
    }
    if ('id' in event && 'name' in event) {
      userOrTeam = 'Team';
    }

    const serviceMethod = selected
      ? `add${userOrTeam}ToTerritory`
      : `remove${userOrTeam}FromTerritory`;

    this.territoryService[serviceMethod](
      userId || teamId,
      territoryId
    ).subscribe(() => {
      this.listTerritories();
      this.pubMethods.showInfoMessage('Your territory was updated.');
    });
  }
}
